import action_calendar from './action-calendar.svg';
import action_add from './action-add.svg';
import action_attach from './action-attach.svg';
import action_android_face from './action-android-face.svg';
import action_camera from './action-camera.svg';
import action_copy from './action-copy.svg';
import action_close from './action-close.svg';
import action_download from './action-download.svg';
import action_edit from './action-edit.svg';
import action_eye_closed from './action-eye-closed.svg';
import action_eye_open from './action-eye-open.svg';
import action_user_add from './action-user-add.svg';
import action_user_multiple from './action-user-multiple.svg';
import action_user_single from './action-user-single.svg';
import action_settings from './action-settings.svg';
import action_filter from './action-filter.svg';
import action_touch_id from './action-touch-id.svg';
import action_face_id from './action-face-id.svg';
import action_minus from './action-minus.svg';
import action_refresh from './action-refresh.svg';
import action_search from './action-search.svg';
import alert_check from './alert-check.svg';
import action_send from './action-send.svg';
import action_trash from './action-trash.svg';
import alert_activity from './alert-activity.svg';
import alert_help from './alert-help.svg';
import alert_hold from './alert-hold.svg';
import alert_information from './alert-information.svg';
import alert_notification from './alert-notification.svg';
import alert_warning from './alert-warning.svg';
import alert_success from './alert-success.svg';
import comm_call_phone from './comm-call-phone.svg';
import comm_chat from './comm-chat.svg';
import comm_email_default from './comm-email-default.svg';
import comm_email_incoming from './comm-email-incoming.svg';
import comm_email_outgoing from './comm-email-outgoing.svg';
import comm_phone_default from './comm-phone-default.svg';
import comm_phone_emergency from './comm-phone-emergency.svg';
import comm_phone_incoming from './comm-phone-incoming.svg';
import comm_phone_outgoing from './comm-phone-outgoing.svg';
import cs_alerts from './cs-alerts.svg';
import cs_cyber_attack from './cs-cyber-attack.svg';
import cs_emergency_assistance from './cs-emergency-assistance.svg';
import cs_liability_coverage from './cs-liability-coverage.svg';
import cs_remediation from './cs-remediation.svg';
import cs_scan from './cs-scan.svg';
import cs_tech_support_2 from './cs-tech-support-2.svg';
import cs_tech_support from './cs-tech-support.svg';
import file_intake_closed from './file-intake-closed.svg';
import file_intake_open from './file-intake-open.svg';
import file_plan from './file-plan.svg';
import file_resolution from './file-resolution.svg';
import file_resource from './file-resource.svg';
import file_ticket from './file-ticket.svg';
import id_24 from './id-24.svg';
import id_360 from './id-360.svg';
import id_access from './id-access.svg';
import id_alert from './id-alert.svg';
import id_app from './id-app.svg';
import id_balance from './id-balance.svg';
import id_call from './id-call.svg';
import id_car from './id-car.svg';
import id_chat from './id-chat.svg';
import id_consult from './id-consult.svg';
import id_coupon from './id-coupon.svg';
import id_credit from './id-credit.svg';
import id_cyber_attack from './id-cyber-attack.svg';
import id_detection from './id-detection.svg';
import id_detect from './id-detect.svg';
import id_emergency_assistance from './id-emergency-assistance.svg';
import id_family from './id-family.svg';
import id_file_upload from './id-file-upload.svg';
import id_full_service from './id-full-service.svg';
import id_gavel from './id-gavel.svg';
import id_house from './id-house.svg';
import id_identity from './id-identity.svg';
import id_id from './id-id.svg';
import id_key from './id-key.svg';
import id_laptop from './id-laptop.svg';
import id_letters_calls from './id-letters-calls.svg';
import id_letter from './id-letter.svg';
import id_liability_coverage from './id-liability-coverage.svg';
import id_lpi from './id-lpi.svg';
import id_million from './id-million.svg';
import id_money from './id-money.svg';
import id_network from './id-network.svg';
import id_protection from './id-protection.svg';
import id_quality from './id-quality.svg';
import id_remediation from './id-remediation.svg';
import id_response from './id-response.svg';
import id_review from './id-review.svg';
import id_scan from './id-scan.svg';
import id_sign from './id-sign.svg';
import id_social from './id-social.svg';
import id_survey from './id-survey.svg';
import id_ticket from './id-ticket.svg';
import logo_american_express from './logo-american-express.svg';
import logo_discover from './logo-discover.svg';
import logo_facebook from './logo-facebook.svg';
import logo_google from './logo-google.svg';
import logo_apple from './logo-apple.svg';
import logo_linkedin from './logo-linkedin.svg';
import logo_instagram from './logo-instagram.svg';
import logo_mastercard from './logo-mastercard.svg';
import logo_office from './logo-office.svg';
import logo_paypal from './logo-paypal.svg';
import logo_prudential from './logo-prudential.svg';
import logo_twitter from './logo-twitter.svg';
import logo_visa from './logo-visa.svg';
import logo_youtube from './logo-youtube.svg';
import ls_24 from './ls-24.svg';
import ls_360 from './ls-360.svg';
import ls_access from './ls-access.svg';
import ls_alert from './ls-alert.svg';
import ls_app from './ls-app.svg';
import ls_balance from './ls-balance.svg';
import ls_call from './ls-call.svg';
import ls_car from './ls-car.svg';
import ls_chat from './ls-chat.svg';
import ls_consult from './ls-consult.svg';
import ls_coupon from './ls-coupon.svg';
import ls_credit from './ls-credit.svg';
import ls_detection from './ls-detection.svg';
import ls_detect from './ls-detect.svg';
import ls_family from './ls-family.svg';
import ls_file_upload from './ls-file-upload.svg';
import ls_full_service from './ls-full-service.svg';
import ls_gavel from './ls-gavel.svg';
import ls_house from './ls-house.svg';
import ls_identity from './ls-identity.svg';
import ls_id from './ls-id.svg';
import ls_key from './ls-key.svg';
import ls_laptop from './ls-laptop.svg';
import ls_letters_calls from './ls-letters-calls.svg';
import ls_letter from './ls-letter.svg';
import ls_lpi from './ls-lpi.svg';
import ls_million from './ls-million.svg';
import ls_money from './ls-money.svg';
import ls_network from './ls-network.svg';
import ls_prenup from './ls-prenup.svg';
import ls_protection from './ls-protection.svg';
import ls_quality from './ls-quality.svg';
import ls_response from './ls-response.svg';
import ls_review from './ls-review.svg';
import ls_sign from './ls-sign.svg';
import ls_social from './ls-social.svg';
import ls_survey from './ls-survey.svg';
import ls_ticket from './ls-ticket.svg';
import ls_ticket_write from './ls-ticket-write.svg';
import nav_arrow_down from './nav-arrow-down.svg';
import nav_arrow_left from './nav-arrow-left.svg';
import nav_arrow_right from './nav-arrow-right.svg';
import nav_arrow_up from './nav-arrow-up.svg';
import nav_cart from './nav-cart.svg';
import nav_chevron_double_left from './nav-chevron-double-left.svg';
import nav_chevron_double_right from './nav-chevron-double-right.svg';
import nav_chevron_single_down from './nav-chevron-single-down.svg';
import nav_chevron_single_left from './nav-chevron-single-left.svg';
import nav_chevron_single_up from './nav-chevron-single-up.svg';
import nav_chevron_single_right from './nav-chevron-single-right.svg';
import nav_dropdown_arrow_down from './nav-dropdown-arrow-down.svg';
import nav_dropdown_arrow_up from './nav-dropdown-arrow-up.svg';
import nav_external_link from './nav-external-link.svg';
import nav_grid from './nav-grid.svg';
import nav_home from './nav-home.svg';
import nav_list from './nav-list.svg';
import nav_menu_hamburger from './nav-menu-hamburger.svg';
import nav_overflow_menu_horizontal from './nav-overflow-menu-horizontal.svg';
import nav_overflow_menu_vertical from './nav-overflow-menu-vertical.svg';
import nav_shopping_cart from './nav-shopping-cart.svg';
import nav_sidebar from './nav-sidebar.svg';
import object_benefit from './object-benefit.svg';
import object_briefcase from './object-briefcase.svg';
import object_buildings from './object-buildings.svg';
import object_clock from './object-clock.svg';
import object_connection from './object-connection.svg';
import object_data from './object-data.svg';
import object_globe from './object-globe.svg';
import object_graph from './object-graph.svg';
import object_image from './object-image.svg';
import object_location from './object-location.svg';
import object_lock from './object-lock.svg';
import object_manage from './object-manage.svg';
import object_package from './object-package.svg';
import object_podium from './object-podium.svg';
import object_shield from './object-shield.svg';
import object_smartphone from './object-smartphone.svg';
import object_swimlane from './object-swimlane.svg';
import object_truck from './object-truck.svg';
import payment_bank from './payment-bank.svg';
import payment_credit_card from './payment-credit-card.svg';
import payment_money from './payment-money.svg';
import action_sort from './action-sort.svg';
import alert_error from './alert-error.svg';
import object_thumbs_up from './object-thumbs-up.svg';
import object_smile from './object-smile.svg';
import object_heart from './object-heart.svg';
import object_heart_outline from './object-heart-outline.svg';

export const IconsV1: { [char: string]: string } = {
  action_add,
  action_android_face,
  action_attach,
  action_calendar,
  action_camera,
  action_close,
  action_copy,
  action_download,
  action_edit,
  action_eye_closed,
  action_eye_open,
  action_face_id,
  action_filter,
  action_minus,
  action_refresh,
  action_search,
  action_send,
  action_settings,
  action_sort,
  action_touch_id,
  action_trash,
  action_user_add,
  action_user_multiple,
  action_user_single,
  alert_activity,
  alert_check,
  alert_error,
  alert_help,
  alert_hold,
  alert_information,
  alert_notification,
  alert_success,
  alert_warning,
  comm_call_phone,
  comm_chat,
  comm_email_default,
  comm_email_incoming,
  comm_email_outgoing,
  comm_phone_default,
  comm_phone_emergency,
  comm_phone_incoming,
  comm_phone_outgoing,
  cs_alerts,
  cs_cyber_attack,
  cs_emergency_assistance,
  cs_liability_coverage,
  cs_remediation,
  cs_scan,
  cs_tech_support,
  cs_tech_support_2,
  file_intake_closed,
  file_intake_open,
  file_plan,
  file_resolution,
  file_resource,
  file_ticket,
  id_24,
  id_360,
  id_access,
  id_alert,
  id_app,
  id_balance,
  id_call,
  id_car,
  id_chat,
  id_consult,
  id_coupon,
  id_credit,
  id_cyber_attack,
  id_detect,
  id_detection,
  id_emergency_assistance,
  id_family,
  id_file_upload,
  id_full_service,
  id_gavel,
  id_house,
  id_id,
  id_identity,
  id_key,
  id_laptop,
  id_letter,
  id_letters_calls,
  id_liability_coverage,
  id_lpi,
  id_million,
  id_money,
  id_network,
  id_protection,
  id_quality,
  id_remediation,
  id_response,
  id_review,
  id_scan,
  id_sign,
  id_social,
  id_survey,
  id_ticket,
  logo_american_express,
  logo_apple,
  logo_discover,
  logo_facebook,
  logo_google,
  logo_instagram,
  logo_linkedin,
  logo_mastercard,
  logo_office,
  logo_paypal,
  logo_prudential,
  logo_twitter,
  logo_visa,
  logo_youtube,
  ls_24,
  ls_360,
  ls_access,
  ls_alert,
  ls_app,
  ls_balance,
  ls_call,
  ls_car,
  ls_chat,
  ls_consult,
  ls_coupon,
  ls_credit,
  ls_detect,
  ls_detection,
  ls_family,
  ls_file_upload,
  ls_full_service,
  ls_gavel,
  ls_house,
  ls_id,
  ls_identity,
  ls_key,
  ls_laptop,
  ls_letter,
  ls_letters_calls,
  ls_lpi,
  ls_million,
  ls_money,
  ls_network,
  ls_prenup,
  ls_protection,
  ls_quality,
  ls_response,
  ls_review,
  ls_sign,
  ls_social,
  ls_survey,
  ls_ticket,
  ls_ticket_write,
  nav_arrow_down,
  nav_arrow_left,
  nav_arrow_right,
  nav_arrow_up,
  nav_cart,
  nav_chevron_double_left,
  nav_chevron_double_right,
  nav_chevron_single_down,
  nav_chevron_single_left,
  nav_chevron_single_right,
  nav_chevron_single_up,
  nav_dropdown_arrow_down,
  nav_dropdown_arrow_up,
  nav_external_link,
  nav_grid,
  nav_home,
  nav_list,
  nav_menu_hamburger,
  nav_overflow_menu_horizontal,
  nav_overflow_menu_vertical,
  nav_shopping_cart,
  nav_sidebar,
  object_benefit,
  object_briefcase,
  object_buildings,
  object_clock,
  object_connection,
  object_data,
  object_globe,
  object_graph,
  object_heart,
  object_heart_outline,
  object_image,
  object_location,
  object_lock,
  object_manage,
  object_package,
  object_podium,
  object_shield,
  object_smartphone,
  object_smile,
  object_swimlane,
  object_thumbs_up,
  object_truck,
  payment_bank,
  payment_credit_card,
  payment_money,
};

export const ICON_NAMES_V1 = [
  'action_add',
  'action_android_face',
  'action_attach',
  'action_calendar',
  'action_camera',
  'action_close',
  'action_copy',
  'action_download',
  'action_edit',
  'action_eye_closed',
  'action_eye_open',
  'action_face_id',
  'action_filter',
  'action_minus',
  'action_refresh',
  'action_search',
  'action_send',
  'action_settings',
  'action_sort',
  'action_touch_id',
  'action_trash',
  'action_user_add',
  'action_user_multiple',
  'action_user_single',
  'alert_activity',
  'alert_check',
  'alert_error',
  'alert_help',
  'alert_hold',
  'alert_information',
  'alert_notification',
  'alert_success',
  'alert_warning',
  'comm_call_phone',
  'comm_chat',
  'comm_email_default',
  'comm_email_incoming',
  'comm_email_outgoing',
  'comm_phone_default',
  'comm_phone_emergency',
  'comm_phone_incoming',
  'comm_phone_outgoing',
  'cs_alerts',
  'cs_cyber_attack',
  'cs_emergency_assistance',
  'cs_liability_coverage',
  'cs_remediation',
  'cs_scan',
  'cs_tech_support',
  'cs_tech_support_2',
  'file_intake_closed',
  'file_intake_open',
  'file_plan',
  'file_resolution',
  'file_resource',
  'file_ticket',
  'id_24',
  'id_360',
  'id_access',
  'id_alert',
  'id_app',
  'id_balance',
  'id_call',
  'id_car',
  'id_chat',
  'id_consult',
  'id_coupon',
  'id_credit',
  'id_cyber_attack',
  'id_detect',
  'id_detection',
  'id_emergency_assistance',
  'id_family',
  'id_file_upload',
  'id_full_service',
  'id_gavel',
  'id_house',
  'id_id',
  'id_identity',
  'id_key',
  'id_laptop',
  'id_letters_calls',
  'id_letter',
  'id_liability_coverage',
  'id_lpi',
  'id_million',
  'id_money',
  'id_network',
  'id_protection',
  'id_quality',
  'id_remediation',
  'id_response',
  'id_review',
  'id_scan',
  'id_sign',
  'id_social',
  'id_survey',
  'id_ticket',
  'logo_american_express',
  'logo_apple',
  'logo_discover',
  'logo_facebook',
  'logo_google',
  'logo_instagram',
  'logo_linkedin',
  'logo_mastercard',
  'logo_office',
  'logo_paypal',
  'logo_prudential',
  'logo_twitter',
  'logo_visa',
  'logo_youtube',
  'ls_24',
  'ls_360',
  'ls_access',
  'ls_alert',
  'ls_app',
  'ls_balance',
  'ls_call',
  'ls_car',
  'ls_chat',
  'ls_consult',
  'ls_coupon',
  'ls_credit',
  'ls_detect',
  'ls_detection',
  'ls_family',
  'ls_file_upload',
  'ls_full_service',
  'ls_gavel',
  'ls_house',
  'ls_id',
  'ls_identity',
  'ls_key',
  'ls_laptop',
  'ls_letter',
  'ls_letters_calls',
  'ls_lpi',
  'ls_million',
  'ls_money',
  'ls_network',
  'ls_prenup',
  'ls_protection',
  'ls_quality',
  'ls_response',
  'ls_review',
  'ls_sign',
  'ls_social',
  'ls_survey',
  'ls_ticket',
  'ls_ticket_write',
  'nav_arrow_down',
  'nav_arrow_left',
  'nav_arrow_right',
  'nav_arrow_up',
  'nav_cart',
  'nav_chevron_double_left',
  'nav_chevron_double_right',
  'nav_chevron_single_down',
  'nav_chevron_single_left',
  'nav_chevron_single_right',
  'nav_chevron_single_up',
  'nav_dropdown_arrow_down',
  'nav_dropdown_arrow_up',
  'nav_external_link',
  'nav_grid',
  'nav_home',
  'nav_list',
  'nav_menu_hamburger',
  'nav_overflow_menu_horizontal',
  'nav_overflow_menu_vertical',
  'nav_shopping_cart',
  'nav_sidebar',
  'object_benefit',
  'object_briefcase',
  'object_buildings',
  'object_clock',
  'object_connection',
  'object_data',
  'object_globe',
  'object_graph',
  'object_heart',
  'object_heart_outline',
  'object_image',
  'object_location',
  'object_lock',
  'object_manage',
  'object_package',
  'object_podium',
  'object_shield',
  'object_smile',
  'object_smartphone',
  'object_swimlane',
  'object_thumbs_up',
  'object_truck',
  'payment_bank',
  'payment_credit_card',
  'payment_money',
] as const;

export const ICON_COLORS_V1 = [
  'default',
  'B10',
  'B100',
  'B200',
  'B300',
  'G10',
  'G100',
  'G200',
  'G300',
  'N00',
  'N100',
  'N300',
  'N500',
  'N600',
  'N700',
  'N800',
  'N1000',
  'P10',
  'P100',
  'P200',
  'P300',
  'R10',
  'R100',
  'R200',
  'R300',
  'Y10',
  'Y100',
  'Y200',
  'Y300',
  'BRAND50',
  'BRAND100',
  'BRAND200',
  'BRAND300',
] as const;

export type IconNamesV1 = (typeof ICON_NAMES_V1)[number];

export type IconColorsV1 = (typeof ICON_COLORS_V1)[number];
